import { action, observable } from "mobx";
import { api } from "../api";
import { IIcmsClassificacao } from "../model";
import { toast } from "react-toastify";

export class _LookupStore {
  obs = observable({
    icms_classificacoes_loaded: false as boolean,
    icms_classificacoes: [] as IIcmsClassificacao[],
  })

  constructor() {
  }

  @action
  async loadIcmsClassificacoes(estado: string): Promise<void> {
    try {

      let params = {
        estado: estado
      }

      let resp = await api.post("/api/icms_classificacoes", params);

      this.obs.icms_classificacoes = [];
      this.obs.icms_classificacoes = resp.data.itens
      this.obs.icms_classificacoes_loaded = true;

    } catch (ex) {

      toast.error("Erro ao carregar Icms Classificações, tente novamente mais tarde.", {});

    }

  }

  getIcmsClassificacao(id: any): IIcmsClassificacao {
    return this.obs.icms_classificacoes.find(x => x.id == id);
  }

  lookupIcmsClassificacao(id: number): string {
    let c = this.getIcmsClassificacao(id);
    if (c) return c.nome;
  }

  getIcmsClassificacaoDAE(id: number) {
    let c = this.getIcmsClassificacao(id);
    if (c) return c;
  }

}

export const LookupStore = new _LookupStore();
